import { connect } from 'react-redux'
import { change, Field, getFormValues, reduxForm } from 'redux-form'
import styles from './PromoConfiguration.css'
import PromoTimePicker from './PromoTimePicker'
import moment from 'moment'
import DropdownCalendarPromo from 'components/Fields/ReduxForm/DropdownCalendarPromo'
import { setAccordionActiveKey, setIsSubmittedPromoForm } from 'actions/library/promo'
import { Button } from 'react-bootstrap'
import { findIndex } from 'lodash'

const validate = (values) => {
  let errors = {}
  if (values.isHaveTimePeriod) {
    if (!values.days) {
      errors.days = true
    }
    if (!values.hoursFrom) {
      errors.hoursFrom = true
    }
    if (!values.hoursTo) {
      errors.hoursTo = true
    }
    if (!values.date) {
      errors.date = true
    }
  }
  return errors
}

class PromoConfiguration extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      daysOfWeek: [
        {name: 'Sunday', isDisabled: false},
        {name: 'Monday', isDisabled: false},
        {name: 'Tuesday', isDisabled: false},
        {name: 'Wednesday', isDisabled: false},
        {name: 'Thursday', isDisabled: false},
        {name: 'Friday', isDisabled: false},
        {name: 'Saturday', isDisabled: false}
      ]
    }
  }

  componentWillReceiveProps (nextProps) {
    let {prConfig} = nextProps
    if (prConfig) {
      let {date, days} = prConfig
      if (date && days && date.endDate) {
        let newDaysState = this._initialDaysState()
        let diff = this._calculateDateDiff(date.startDate, date.endDate)
        let unBlockedDay = 0
        let checkedDay = 0
        if (diff < 7) {
          for (let i = 0; i <= diff; i++) {
            let currDay = this._getCurrentDay(prConfig.date.startDate, i)
            let idx = this._findIndexInDays(currDay, newDaysState)
            newDaysState[idx].isDisabled = true
            unBlockedDay++
          }
        } else {
          newDaysState.forEach((day, idx) => { newDaysState[idx].isDisabled = true })
          unBlockedDay = 7
        }
        newDaysState.forEach((day, idx) => {
          if (days[idx]) {
            if (!day.isDisabled && days[idx].checked) {
              this.props.dispatch(change('promoConfig', `days[${idx}].checked`, ''))
            } else if (day.isDisabled && days[idx].checked) {
              checkedDay++
            }
          }
        })
        if (unBlockedDay === checkedDay) {
          this.props.dispatch(change('promoConfig', 'selectAllDays', true))
        }
      }
    }
  }

  componentDidUpdate (prevProps, prevState) {
    let {prConfig} = this.props
    if (prConfig) {
      let {date, days} = prConfig
      if (date && days && date.endDate) {
        let newDaysState = this._initialDaysState()
        let diff = this._calculateDateDiff(date.startDate, date.endDate)
        let unBlockedDay = 0
        let checkedDay = 0
        if (diff < 7) {
          for (let i = 0; i <= diff; i++) {
            let currDay = this._getCurrentDay(date.startDate, i)
            let idx = this._findIndexInDays(currDay, newDaysState)
            newDaysState[idx].isDisabled = true
            unBlockedDay++
          }
        } else {
          unBlockedDay = 7
          newDaysState.forEach((day, idx) => { newDaysState[idx].isDisabled = true })
        }
        newDaysState.forEach((day, idx) => {
          if (day.isDisabled && days[idx] && days[idx].checked) {
            checkedDay++
          }
        })
        if (checkedDay !== unBlockedDay) {
          this.props.dispatch(change('promoConfig', 'selectAllDays', ''))
        } else {
          this.props.dispatch(change('promoConfig', 'selectAllDays', true))
        }
      }
    }
  }

  _calculateDateDiff = (startDate, endDate) => {
    return moment(endDate).diff(startDate, 'days')
  }

  _getCurrentDay = (startDate, iterator) => {
    return moment(startDate).add(iterator, 'days').format('dddd')
  }

  _findIndexInDays = (currentDay, daysCollection) => {
    return findIndex(daysCollection, (day) => { return day.name === currentDay })
  }

  _initialDaysState = () => {
    // nama variable yang sebenernya adalah isNotDisable
    // karena cara kerja logicnya adalah buat semua disabled dulu
    // dan enable tanggal yang berada pada range tersebut
    return [
      {name: 'Sunday', isDisabled: false},
      {name: 'Monday', isDisabled: false},
      {name: 'Tuesday', isDisabled: false},
      {name: 'Wednesday', isDisabled: false},
      {name: 'Thursday', isDisabled: false},
      {name: 'Friday', isDisabled: false},
      {name: 'Saturday', isDisabled: false}
    ]
  }

  render () {
    let {prConfig} = this.props

    let {daysOfWeek} = this.state
    let newDaysState = this._initialDaysState()
    let isAvailable = 0
    let dayCheked = 0
    let diff = 0

    if (prConfig && prConfig.date) {
      diff = this._calculateDateDiff(prConfig.date.startDate, prConfig.date.endDate)
      if (diff < 7) {
        for (let i = 0; i <= diff; i++) {
          let currDay = this._getCurrentDay(prConfig.date.startDate, i)
          let idx = this._findIndexInDays(currDay, daysOfWeek)
          newDaysState[idx].isDisabled = true
        }
      } else {
        newDaysState.forEach((day, idx) => { newDaysState[idx].isDisabled = true })
      }
      newDaysState.forEach((day, idx) => {
        isAvailable += day.isDisabled ? 1 : 0
        dayCheked += prConfig.days[idx] && prConfig.days[idx].checked ? 1 : 0
      })
    }

    return <div>
      <form>
        <div className='checkbox'>
          <Field
            type='checkbox'
            name='isAppliesToMultiple'
            id='isAppliesToMultiple'
            component='input'
          />
          <label htmlFor='isAppliesToMultiple'>Applies in multiple</label>
        </div>
        <small className={styles['eg-applies-multiple']}>
          e.g if there is a 'buy 1 get 1 free' promo, customers who buy 2 will get 2 free
        </small>
        <div className='checkbox'>
          <Field
            type='checkbox'
            name='isHaveTimePeriod'
            id='isHaveTimePeriod'
            component='input'
            onChange={(e) => {
              if (!prConfig.isHaveTimePeriod) { // promo does not have a time period
                this.props.dispatch(change('promoConfig', 'hoursFrom', moment().startOf('day')))
                this.props.dispatch(change('promoConfig', 'hoursTo', moment().endOf('day')))
                this.props.dispatch(change('promoConfig', 'date', {
                  startDate: moment().add(1, 'days').startOf('day').toISOString(),
                  endDate: moment().add(2, 'days').endOf('day').toISOString()
                }))
                const checkedDays = this._initialDaysState()
                checkedDays[parseInt(moment().add(1, 'days').format('d'))].checked = true
                checkedDays[parseInt(moment().add(2, 'days').format('d'))].checked = true
                this.props.dispatch(change('promoConfig', 'selectAllDays', true))
                this.props.dispatch(change('promoConfig', 'days', checkedDays))
              }
            }}
          />
          <label htmlFor='isHaveTimePeriod'>Set promo time period</label>
        </div>

        {prConfig && !prConfig.isHaveTimePeriod && <small className={styles['eg-applies-multiple']}>
          By not setting a promo time period, this promo will run forever starting tomorrow. You can setup it later.
        </small>}

        {
          prConfig && prConfig.isHaveTimePeriod &&
          <div className={styles['time-period-wrapper']}>
            <div className='col-sm-12'>
              <div className={`col-sm-3 ${styles['no-padding']}`}>
                <label className={styles.config}>Select date</label>
              </div>
              <div className={`col-sm-9 ${styles['no-padding']}`}>
                <Field
                  name='date'
                  component={DropdownCalendarPromo}
                  onChange={this._onChangeDate}
                  updateServerOnChange
                />
              </div>
            </div>

            <div className='col-sm-12'>
              <div className={`col-sm-3 ${styles['no-padding']}`}>
                <label className={styles.config}>Select hour</label>
              </div>
              <div className={`col-sm-9 ${styles['no-padding']}`}>
                <div className={`col-sm-2 ${styles['no-padding']} ${styles['input-time']}`}>
                  <Field
                    name='hoursFrom'
                    component={PromoTimePicker}
                    showSecond={false}
                    allowEmpty={false}
                    onChangeValue={(e) => {
                      if (moment(e).isBefore(prConfig.hoursTo)) {
                        this.props.dispatch(change('promoConfig', 'hoursFrom', e))
                      }
                    }}
                  />
                </div>
                <div className={`col-sm-1 ${styles['no-padding']} text-center`}>-</div>
                <div className={`col-sm-2 ${styles['no-padding']} ${styles['input-time']}`}>
                  <Field
                    name='hoursTo'
                    component={PromoTimePicker}
                    showSecond={false}
                    allowEmpty={false}
                    onChangeValue={(e) => {
                      if (moment(e).isAfter(prConfig.hoursFrom)) {
                        this.props.dispatch(change('promoConfig', 'hoursTo', e))
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className='col-sm-12'>
              <div className={`col-sm-3 ${styles['no-padding']}`}>
                <label className={styles.config}>Select day</label>
              </div>
              <div className={`col-sm-9 ${styles['no-padding']}`}>
                <div className='checkbox'>
                  <Field
                    name='selectAllDays'
                    id='selectAllDays'
                    component='input'
                    type='checkbox'
                    onChange={(e) => {
                      for (let idx = 0; idx < newDaysState.length; idx++) {
                        if (newDaysState[idx].isDisabled) {
                          this.props.dispatch(change('promoConfig', `days[${idx}].checked`, !e.target.value))
                        } else {
                          this.props.dispatch(change('promoConfig', `days[${idx}].checked`, ''))
                        }
                      }
                    }}
                  />
                  <label htmlFor='selectAllDays'>{isAvailable !== dayCheked ? 'Select All' : 'Unselect All'}</label>
                </div>
                {newDaysState.map((day, index) => {
                  return (<div className='checkbox'>
                    <Field
                      key={index}
                      name={`days[${index}].checked`}
                      type='checkbox'
                      component='input'
                      className='pull-left'
                      id={`days[${index}]`}
                      disabled={!day.isDisabled}
                      onChange={(e) => {
                        this.props.dispatch(change('promoConfig', `days[${index}].name`, day.name))
                        this.props.dispatch(change('promoConfig', 'selectAllDays', isAvailable === dayCheked ? true : ''))
                      }} />
                    <label htmlFor={`days[${index}]`}>{day.name}</label>
                    <br />
                  </div>)
                })}
              </div>
            </div>
          </div>
        }
        <Button
          bsStyle='default'
          type='button'
          className={styles['btn-previous']}
          onClick={this._handlePrevious}>
          Previous
        </Button>
      </form>
    </div>
  }

  _onChangeDate = ({startDate, endDate}) => {
    this.props.dispatch(change('promoConfig', 'date', {startDate, endDate}))
  }

  _handlePrevious = () => {
    const {isSubmitPromoForm} = this.props
    let newPromoState = {...isSubmitPromoForm}
    newPromoState['promoConfig'] = true
    this.props.dispatch(setIsSubmittedPromoForm(newPromoState))
    this.props.dispatch(setAccordionActiveKey('3'))
  }
}

function mapStateToProps (state) {
  const {detailPromo, isSubmitPromoForm} = state.library.promo
  return {
    search: getFormValues('search')(state),
    prConfig: getFormValues('promoConfig')(state),
    detailPromo,
    isSubmitPromoForm
  }
}

const mapForm = {
  form: 'promoConfig',
  touchOnBlur: false,
  touchOnChange: false,
  validate
}

export default connect(mapStateToProps)(reduxForm(mapForm)(PromoConfiguration))



// WEBPACK FOOTER //
// ./app/pages/Library/Promo/DetailPromo/PromoForm/PromoConfiguration/PromoConfiguration.js